module.exports = __webpack_public_path__ + "img/t2.ec422664.png";